import { render } from "./SubmitOrder.vue?vue&type=template&id=717db096&scoped=true"
import script from "./SubmitOrder.vue?vue&type=script&lang=js"
export * from "./SubmitOrder.vue?vue&type=script&lang=js"

import "./SubmitOrder.vue?vue&type=style&index=0&id=717db096&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717db096"]])

export default __exports__